export default {
	"foreaccountroad": {
		"settlementStatus": "结算状态"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/foreaccount/foreaccount.js